import WhiteLogo from "@/components/icons/WhiteLogo";

const Step2ContentPreview = () => {
  return (
    <div className="bg-primary lg:rounded-[20px] shadow-md p-6 lg:p-10 text-white flex flex-col lg:items-center justify-center text-center h-[calc(100%-0.5rem)] object-cover lg:mt-1">
      <WhiteLogo />
      <img
        className="h-[60vw] lg:h-[20vw] w-[60vw] lg:w-[20vw] ml-auto mr-auto mt-6 lg:mt-0"
        src="/otp-img.png"
        alt="group-icon"
      />
    </div>
  );
};

export default Step2ContentPreview;
